import { getState, patchState, signalStoreFeature, withHooks, withMethods, withState } from '@ngrx/signals';

type FilterStr = {
    filterStr: string[];
}

const initialState: FilterStr = {
    filterStr: []
};

export function withFilterStr() {
    return signalStoreFeature(
        withState(initialState),
        withMethods((store) => ({
            addFilterStr(str: string) {
                const state = getState(store);
                patchState(store, { filterStr: [...state.filterStr, str] });
            },
            removeFilterStr(str: string) {
                const state = getState(store);
                patchState(store, { filterStr: state.filterStr.filter((item) => item !== str) });
            },

        })),
    );
}